<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('messages')"
      :columns="columns"
      :column_search="true"
      resource_url="/whatsapp/message/datatables"
    >
      <template v-slot:buttons>
        <!-- <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/whatsapp/settings' })"
        >
          <span class="icon"><i class="fa fa-cogs"></i></span>
          <span>{{ $t("settings") }}</span>
        </button> -->
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <whatsapp-message-modal ref="whatsapp_message_modal" @success="refresh" />
    <message-modal ref="message_modal" />
    <!-- <detail-modal ref="detail_modal" /> -->
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
} from "@/utils";
import WhatsappMessageModal from "../whatsapp_message_modal/Index.vue";
import MessageModal from "../message_modal/Index.vue";
// import DetailModal from "../detail_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "MessagesDatatable",
  components: {
    GenericTable,
    WhatsappMessageModal,
    MessageModal /* DetailModal */,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("phone number"),
          searchable: false,
          data: (row) => {
            return row.settings.phone_number || "";
          },
        },
        {
          title: v.$t("message"),
          searchable: false,
          // width: "30%",
          data: (row) => {
            return truncate(row.settings.message || "", { length: 65 });
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          // width: "30%",
          data: (row) => {
            return v.translate_status(row.status_code);
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "55%",
        //   data: (row) => {
        //     // return truncate(JSON.stringify(row), { length: 65 });
        //     return `<pre>${JSON.stringify(row)}</pre>`;
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.message_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete message?"),
                    v,
                    () => {
                      del("/whatsapp/message", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    create() {
      let v = this;
      v.$refs.whatsapp_message_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status) {
      let v = this;
      switch (status) {
        case "C":
          return v.$t("created");
        case "E":
          return v.$t("errored");
        case "T":
          return v.$t("token retrieved");
        case "D":
          return v.$t("data retrieved");
        default:
          return status;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
